(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /* Barra Filtra | Ordina sticky su mobile: --zw-bar-top = bordo inferiore
     reale dell'header (vedi il CSS di .facets-container). getBoundingClientRect
     legge anche il transform in corso, quindi durante l'animazione di
     comparsa/scomparsa della navbar la barra la segue frame per frame.
     Il loop gira solo mentre si scorre (+400ms per coprire la fine della
     transizione dell'header, .15s), poi si ferma: a pagina ferma, zero lavoro. */
  (function () {
    var mobile = window.matchMedia('(max-width: 749px)');
    var frame = 0;
    var until = 0;

    function tick() {
      var bar = document.querySelector('.collection-wrapper .facets-container');
      var header = document.querySelector('.shopify-section-header');
      if (bar && header && mobile.matches) {
        var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        bar.style.setProperty('--zw-bar-top', bottom + 'px');
        var stuck = bottom + 1 >= bar.getBoundingClientRect().top;
        bar.classList.toggle('is-stuck', stuck);
      }
      frame = performance.now() > until ? 0 : requestAnimationFrame(tick);
    }

    function kick() {
      until = performance.now() + 400;
      if (!frame) frame = requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    kick();

    // Lente della riga unica: riporta dentro l'header e mette il cursore nel
    // suo campo di ricerca. preventHide (StickyHeader, header-zerow) evita che
    // la tastiera che si apre, scorrendo la pagina, lo rinasconda subito.
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-zw-bar-search]')) return;
      // Con la ricerca a tutto schermo (zw-search, variante sheet) la lente la
      // apre e basta: l'header resta nascosto, cosi' chiudendola si ritrova la
      // barra Filtra | Ordina com'era. Rivelare l'header lasciava la barra sotto
      // di lui (la sua posizione si ricalcola solo scorrendo).
      if (document.querySelector('[data-variant="sheet"]')) {
        var q = document.querySelector('.zw-navsearch input[type="search"]');
        document.dispatchEvent(new CustomEvent('zw:search-sheet', { detail: { q: q ? q.value : '', origin: event.target.closest('[data-zw-bar-search]') } }));
        return;
      }
      var sticky = document.querySelector('sticky-header');
      var input = document.querySelector('.zw-navsearch input[type="search"]');
      if (sticky && sticky.reveal) {
        sticky.preventHide = true;
        sticky.reveal();
      }
      if (input) {
        input.focus({ preventScroll: true });
        input.addEventListener('blur', function () {
          if (sticky) sticky.preventHide = false;
        }, { once: true });
      }
      kick();
    });

    // Menu ordinamento del tema (desktop e foglio mobile). La scelta va al
    // select nascosto indicato da data-target (#SortBy nel form desktop,
    // #SortBy-mobile nel drawer) con un evento input: facets.js applica
    // l'ordinamento insieme ai filtri, come col select nativo.
    function closeSort(except) {
      document.querySelectorAll('.zw-sort.is-open').forEach(function (menu) {
        if (menu === except) return;
        menu.classList.remove('is-open');
        menu.querySelector('.zw-sort__toggle').setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.zw-sort__toggle');
      var option = event.target.closest('.zw-sort__option');
      var menu = event.target.closest('.zw-sort');

      if (toggle) {
        var open = !menu.classList.contains('is-open');
        closeSort(menu);
        menu.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var current = menu.querySelector('.zw-sort__option[aria-current="true"]') || menu.querySelector('.zw-sort__option');
          if (current) current.focus({ preventScroll: true });
        }
        return;
      }

      if (option) {
        var select = document.getElementById(menu.dataset.target);
        if (select) {
          select.value = option.dataset.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
        }
        menu.querySelectorAll('.zw-sort__option').forEach(function (el) {
          if (el === option) el.setAttribute('aria-current', 'true');
          else el.removeAttribute('aria-current');
        });
        var label = menu.querySelector('.zw-sort__current');
        if (label) label.textContent = option.textContent.trim();
        // barra mobile: il bottone dice sempre il criterio attivo
        var barLabel = menu.querySelector('.zw-sort__bar-label');
        if (barLabel) barLabel.textContent = option.dataset.short;
        // annuncio per gli screen reader ("Ordina per: Prezzo crescente")
        var status = menu.querySelector('[data-zw-sort-status]');
        if (status) status.textContent = menu.dataset.statusPrefix + ' ' + option.textContent.trim();
        closeSort();
        menu.querySelector('.zw-sort__toggle').focus({ preventScroll: true });
        return;
      }

      // fuori dal menu, o sullo sfondo scurito del foglio mobile
      if (!menu || event.target.classList.contains('zw-sort__backdrop')) closeSort();
    });

    document.addEventListener('keydown', function (event) {
      var menu = document.querySelector('.zw-sort.is-open');
      if (!menu) return;
      if (event.key === 'Escape') {
        closeSort();
        menu.querySelector('.zw-sort__toggle').focus();
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var items = Array.prototype.slice.call(menu.querySelectorAll('.zw-sort__option'));
      var index = items.indexOf(document.activeElement);
      var step = event.key === 'ArrowDown' ? 1 : -1;
      var next = items[(index + step + items.length) % items.length];
      if (next) {
        event.preventDefault();
        next.focus();
      }
    });

    // Dopo un nuovo ordinamento o filtro, se si era scesi nella pagina si torna
    // all'inizio della griglia (sotto header e barra), cosi' si vedono i primi
    // risultati del nuovo ordine. facets.js riscrive #ProductGridContainer:
    // si osservano solo i suoi figli diretti, quindi "carica altro" (che
    // aggiunge card dentro la lista) non fa scattare niente.
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(function () {
        var header = document.querySelector('.shopify-section-header');
        var bar = document.querySelector('.collection-wrapper .facets-container');
        var offset = (header ? header.offsetHeight : 0) + (mobile.matches && bar ? bar.offsetHeight : 0) + 8;
        var top = grid.getBoundingClientRect().top;
        if (offset > top) {
          window.scrollTo({ top: window.scrollY + top - offset, behavior: 'smooth' });
        }
      }).observe(grid, { childList: true });
    }

    // Pannello Filtra: .zw-has-more sui contenitori che scorrono (elenco e
    // sottomenu) finche' hanno contenuto sotto; accende la sfumatura sopra la
    // fascia della CTA. Si ricontrolla allo scorrimento (in cattura: lo
    // scroll non risale), all'apertura dei sottomenu (dopo l'animazione da
    // .4s) e al resize.
    function updateMore(el) {
      // contenitore non visibile (drawer chiuso, sottomenu non aperto): mai
      var visible = el.clientHeight > 0 && el.getClientRects().length > 0;
      el.classList.toggle('zw-has-more', visible && el.scrollHeight - el.scrollTop - el.clientHeight > 4);
    }

    function updateAllMore() {
      document.querySelectorAll('.zw-mobile-toolbar .mobile-facets__inner, .zw-mobile-toolbar .mobile-facets__submenu').forEach(updateMore);
    }

    document.addEventListener('scroll', function (event) {
      var el = event.target;
      if (el.classList && (el.classList.contains('mobile-facets__inner') || el.classList.contains('mobile-facets__submenu'))) updateMore(el);
    }, true);

    document.addEventListener('click', function (event) {
      // subito (frame dopo il clic) e a fine animazione del drawer (.4s): prima
      // si ricalcolava solo dopo 450ms e per quel tempo restava lo stato
      // precedente, cioe' l'ombra accesa dove non serviva piu'
      if (event.target.closest('.zw-mobile-toolbar')) {
        requestAnimationFrame(updateAllMore);
        setTimeout(updateAllMore, 450);
      }
    });

    window.addEventListener('resize', updateAllMore);

    // facets.js aggiorna #ProductCount quando cambiano i filtri: e' il segnale
    // per ricalcolare "Mostra N risultati" e l'ombra "c'e' altro sotto".
    var source = document.getElementById('ProductCount');
    if (source) {
      new MutationObserver(function () {
        // i sottomenu sono stati riscritti: la sfumatura "c'e' altro" va ricalcolata
        updateAllMore();
      }).observe(source, { childList: true, characterData: true, subtree: true });
    }

    // "Mostra N risultati". facets.js NON ridisegna il gruppo di filtri in cui
    // si sta cliccando (renderFilters salta il .js-filter dell'evento), quindi
    // il bottone dentro quel gruppo resta con il numero vecchio. Copiarlo dal
    // DOM (prima versione) prendeva il primo gruppo trovato: con "Colore" primo
    // era proprio quello vecchio, e selezionando piu' colori il numero non si
    // aggiornava (2026-10-09). Il numero fresco sta nell'HTML appena scaricato:
    // si prende da li', agganciandosi a renderProductCount, che gira sia dopo
    // il fetch sia dalla cache. facets.js e' defer nel body e questo
    // blocco e' defer nell'head: al DOMContentLoaded sono eseguiti tutti e due.
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof FacetFiltersForm === 'undefined') return;
      var origCount = FacetFiltersForm.renderProductCount;
      FacetFiltersForm.renderProductCount = function (html) {
        origCount.call(FacetFiltersForm, html);
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#FacetFiltersFormMobile [data-zw-apply-count]');
        if (!fresh) return;
        document.querySelectorAll('#FacetFiltersFormMobile [data-zw-apply-count]').forEach(function (el) {
          el.textContent = fresh.textContent;
        });
      };
      // Risposte fuori ordine: due click a piu' di 500ms (il debounce) di
      // distanza sono due fetch; se la prima risponde dopo la seconda, griglia
      // e contatore tornano indietro. Si rende solo l'ultima richiesta
      // (searchParamsPrev); le altre finiscono solo in cache, come prima.
      FacetFiltersForm.renderSectionFromFetch = function (url, event) {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          FacetFiltersForm.filterData = FacetFiltersForm.filterData.concat([{ html: html, url: url }]);
          if (url.indexOf('&' + FacetFiltersForm.searchParamsPrev) < 0) return;
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        });
      };
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-left-logo-zerow"] && !Shopify.designMode) return;
  try {
    /* Segna i cuori dei prodotti gia' in wishlist (.zw-wl-saved), cosi' restano
     visibili anche senza hover (CSS sopra). Legge la lista che Wishlist Hero
     salva in localStorage (store2, namespace "wishlisthero_", chiave che finisce
     con "wl-itms", array di articoli con ProductId) invece del markup dell'app,
     che e' generato a runtime e non ha una classe di stato. Si riallinea a ogni
     aggiunta/rimozione (evento dell'app) e fra schede (storage).
     ponytail: le card caricate dopo (load more, filtri) si allineano al primo
     evento successivo; se serve subito, chiamare zwWishlistSync() dopo il render. */
  (function () {
    function savedIds() {
      var ids = {};
      try {
        // all'indietro: niente "<" in un blocco javascript (vedi CLAUDE.md)
        for (var i = localStorage.length - 1; i >= 0; i--) {
          var key = localStorage.key(i);
          if (!/wl-itms$/.test(key)) continue;
          var items = JSON.parse(localStorage.getItem(key));
          if (!Array.isArray(items)) continue;
          items.forEach(function (item) {
            var id = item && (item.ProductId || item.productId);
            if (id) ids[String(id)] = true;
          });
        }
      } catch (e) {}
      return ids;
    }

    function sync() {
      var ids = savedIds();
      document.querySelectorAll('.wishlisthero-floating[data-wlh-id]').forEach(function (el) {
        el.classList.toggle('zw-wl-saved', !!ids[el.getAttribute('data-wlh-id')]);
      });
    }

    window.zwWishlistSync = sync;
    ['DOMContentLoaded', 'wishlist-hero-wishlist-updated', 'wishlist-hero-wishlist-sdk-ready'].forEach(function (name) {
      document.addEventListener(name, sync);
    });
    window.addEventListener('storage', sync);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
